
export const Spinner = () => {
    return (
        <div style={{ borderTopColor: 'transparent', display:'inline-block', verticalAlign:'middle' }}  className="w-5 h-5 border-4 ml-5 border-white-400 border-solid rounded-full animate-spin"></div>
    )
}
